/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 2 hook(s) need dependency review; fix each and remove this directive */
import { getBackendUrl } from "@Utils";
import { useTranslation } from "@i18n";
import DeleteIcon from "@Components/StickySidebarViewer/assets/DeleteIcon";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import SlickGrid1 from "@CubeComponents/html/SlickGrid1";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import IconComponent from "@CubeComponents/icons";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { showToastNotification } from "@Reducers/toastSlice";
import { TOAST_TYPE_WARNING } from "@Services/constants";
import { convertDate } from "@Services/luxonHelper";
import ToolTipComponent from "@CubeComponents/html/tooltip";
import { referencedFilesInReviews } from "./ReviewsHelper";
import { uploadStringToTemp } from "@Services/tempUpload";
import { PlusIcon } from "@Components/StickySidebarViewer/assets/selectionIcons";

import { renderUserTag } from "@CubeComponents/html/userTagDom";
import { portalCreateRoot } from "@CubeComponents/html/cellPortals";
function Attachments({ closeAttachmentModal, viewMode = true, attachments, fileVersionId, reviewId }) {
  const { t } = useTranslation();
  const [attachedFilesData, setAttachedFilesData] = useState(attachments);
  const dataGrid = useRef<any>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const attachedFilesDataRef = useRef(attachedFilesData);
  const dispatch = useDispatch();

  const buttonClicked = () => {
    fileInputRef.current!.click();
  };

  const attachBtnTemplate = () => (
    <>
      <ButtonComponent buttonType={BUTTON_TYPES.BACKGROUND_BUTTON} id="attach" onClick={buttonClicked} className="me-7">
        <span className="flex items-center gap-1">
          <PlusIcon color="var(--primary-text)" />
          {t("Attach")}
        </span>
      </ButtonComponent>
      <input
        type="file"
        ref={fileInputRef}
        accept="image/png,image/jpg,image/jpeg,application/pdf,.xls,.xlsx,.csv,.xml"
        className="hidden"
        onChange={handleFileChange}
      />
    </>
  );

  const removeBtnTemplate = () => (
    <span className="me-7 flex items-center gap-1 cursor-pointer" id="remove">
      <DeleteIcon size="15" className="" />
      {t("Delete")}
    </span>
  );

  const downLoadTemplate = () => (
    <div className="flex items-center cursor-pointer" id="download">
      <IconComponent name="download" width="1.5rem" height="1.5rem" className="me-2" />
      <span>{t("Download")}</span>
    </div>
  );

  const toolbarOptions = useMemo(
    () => [
      {
        align: "Left",
        template: attachBtnTemplate,
        id: "attach",
      },
      {
        align: "Left",
        template: removeBtnTemplate,
        id: "remove",
      },
      {
        align: "Left",
        template: downLoadTemplate,
        id: "download",
      },
    ],

    [],
  );

  useEffect(() => {
    attachedFilesDataRef.current = attachedFilesData;
  }, [attachedFilesData]);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    const name = file.name;
    const size = file.size;
    fileInputRef.current!.value = "";
    if (size > 10485760) {
      return dispatch(
        showToastNotification({
          content: t("Selected file is larger than {{max, number}} MB!", { max: 10 }),
          type: TOAST_TYPE_WARNING,
        }),
      );
    }
    const isDataExist = attachedFilesDataRef.current.find((file) => file.name === name);
    if (isDataExist) {
      return dispatch(showToastNotification({ content: t("Selected file already exists!"), type: TOAST_TYPE_WARNING }));
    }

    const tempKey = await uploadStringToTemp(file, name);
    if (!tempKey) {
      return dispatch(showToastNotification({ content: t("File upload failed!"), type: TOAST_TYPE_WARNING }));
    }

    const response = await referencedFilesInReviews({
      uploadRefrencedFiles: tempKey,
      name,
      fileVersionId,
      reviewId,
      action: "update",
    });
    setAttachedFilesData((prev: any) => [...prev, response.data.data]);
  };

  const handleDownloadClick = (awsKey, name) => {
    const url = `${getBackendUrl()}/fileSystemServer/referencedFileDownload?awsFileName=${awsKey}&fileName=${name}&origin=${location.hostname}`;
    window.open(url, "_blank");
  };

  const headerContent = () => (
    <div className="  w-full flex justify-between rounded-md items-center">
      <div className="">{viewMode ? t("View Attachments") : t("Add Attachments")}</div>
    </div>
  );

  const toolbarClickHandler = useCallback(
    (toolClicked) => {
      const selectedRecords = dataGrid.current?.dataView?.getAllSelectedItems() || [];
      const selectedRecordsKey = selectedRecords.map((file) => file._id);

      if (toolClicked === "remove" && selectedRecordsKey.length > 0) {
        const updatedFilesData = attachedFilesDataRef.current.filter((file) => !selectedRecordsKey.includes(file._id));
        setAttachedFilesData(updatedFilesData);
        referencedFilesInReviews({
          action: "delete",
          deleteAttachedFiles: selectedRecordsKey,
          reviewId,
          fileVersionId,
        });
      }

      if (toolClicked === "download" && selectedRecordsKey.length === 1) {
        const { awsKey, name } = attachedFilesDataRef.current.find((file) => selectedRecordsKey.includes(file._id));
        handleDownloadClick(awsKey, name);
      }
    },
    [reviewId, fileVersionId],
  );

  const rawSelectionEvent = () => {
    if (dataGrid.current) {
      const selectedRecords = dataGrid.current?.dataView?.getAllSelectedItems() || [];
      if (selectedRecords.length === 0) {
        dataGrid.current.toolbarModule?.enableItems(["remove", "download"], false);
      } else if (selectedRecords.length === 1) {
        dataGrid.current.toolbarModule?.enableItems(["remove", "download"], true);
      } else {
        dataGrid.current.toolbarModule?.enableItems(["remove"], true);
        dataGrid.current.toolbarModule?.enableItems(["download"], false);
      }
    }
  };

  const dateFormatter = (row, cell, value, columnDef, dataContext) => {
    const dateFormat = convertDate(Number(dataContext.createdDate), "dateForTooltip");
    const container = document.createElement("div");
    container.style.width = "fit-content";
    portalCreateRoot(container).render(
      <ToolTipComponent showTipPointer position="bottom" content={dateFormat}>
        <span>{convertDate(Number(dataContext.createdDate), "dateForText")}</span>
      </ToolTipComponent>,
    );
    return container;
  };

  const userNameFormatter = (row, cell, value, columnDef, dataContext) => {
    const { userDetails } = dataContext;
    const container = document.createElement("div");
    renderUserTag(container, { id: userDetails?._id });
    return container;
  };

  const columnDefinitions = useMemo(
    () => [
      {
        id: "name",
        field: "name",
        name: t("Name"),
        minWidth: 150,
        clipMode: "EllipsisWithTooltip",
      },
      {
        id: "userDetails",
        field: "userDetails.userName",
        name: t("Uploaded by"),
        minWidth: 150,
        formatter: userNameFormatter,
        _valueGetter: (row: any) => row?.userDetails?._id,
        _excelValueGetter: (row: any) =>
          row?.userDetails?.userName || row?.userDetails?.fullName || row?.userDetails?._id || "",
        disableFiltering: true,
        disableSorting: true,
        disableGrouping: true,
      },
      {
        id: "createdDate",
        field: "createdDate",
        name: t("Uploaded On"),
        minWidth: 150,
        formatter: dateFormatter,
        filterType: "date",
        _excelValueGetter: (row: any) => (row.createdDate ? convertDate(Number(row.createdDate), "dateForText") : ""),
      },
      {
        id: "level",
        field: "level",
        name: t("Uploaded at Level"),
        minWidth: 120,
        clipMode: "EllipsisWithTooltip",
      },
    ],
    [],
  );

  const attachedFilesGrid = useCallback(
    () => (
      <SlickGrid1
        ref={dataGrid as any}
        toolbar={toolbarOptions as any}
        dataset={attachedFilesData}
        columnDefinitions={columnDefinitions as any}
        toolbarClickHandler={toolbarClickHandler as any}
        onSelectedRowIdsChanged={rawSelectionEvent}
        rowHeight={50}
        gridHeight="100%"
        enableSortingOption
        infiniteScroll
        enableFilteringOption
        enableGroupingOption
        enableColumnChooser
        excelExport
        hideNoDataIllustration
      />
    ),

    [attachedFilesData, columnDefinitions],
  );

  const modelContent = () => (
    <div className="flex gap-4 flex-col max-h-115 overflow-auto">
      <div className="flex flex-col border-2 border-button_light rounded-t-md h-90">{attachedFilesGrid()}</div>
    </div>
  );

  return (
    <ModalStateDialogComponent
      {...({ allowModalPadding: false, closeModal: true } as any)}
      width="70%"
      headerTitle={headerContent()}
      onCancel={closeAttachmentModal}
      modelContent={modelContent()}
      isVisible
    />
  );
}

export default Attachments;
